'use client'
import { useRouter } from 'next/navigation'
import { useState, useRef } from 'react'

export function SearchBar({ placeholder }: { placeholder?: string }) {
  const router = useRouter()
  const [q, setQ] = useState('')
  const inputRef = useRef<HTMLInputElement>(null)

  function submit() {
    const term = q.trim()
    if (term) router.push(`/search?q=${encodeURIComponent(term)}`)
  }

  return (
    <div className="search-wrap" onClick={() => inputRef.current?.focus()}>
      <span className="search-circle" />
      <input
        ref={inputRef}
        value={q}
        onChange={e => setQ(e.target.value)}
        onKeyDown={e => e.key === 'Enter' && submit()}
        placeholder={placeholder ?? 'Search places, people, events…'}
      />
    </div>
  )
}
